import {
    ROUTES_SIGN_UP_SUCCESS,
    ROUTES_LOGIN,
    ROUTES_LOGOUT,
    ROUTES_FORGOT_PASSWORD,
    ROUTES_RESEND_ACTIVATION_EMAIL
} from '@/constants/routes';

export const logout = {
    path: '/logout',
    name: ROUTES_LOGOUT
};

export default {
    path: '/auth',
    name: 'auth',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: 'auth' */ '@/views/auth/AuthRoot.vue'),
    meta: {
        requiresAuth: false,
        guest: true
    },
    children: [
        {
            path: '/login',
            name: ROUTES_LOGIN,
            props: true,
            component: () => import(/* webpackChunkName: 'auth' */ '@/views/auth/AuthLogin.vue')
        },
        {
            path: '/sign-up-success',
            name: ROUTES_SIGN_UP_SUCCESS,
            props: true,
            component: () => import(/* webpackChunkName: 'auth' */ '@/views/auth/AuthRegisterSuccess.vue')
        },
        {
            path: '/forgot-password',
            name: ROUTES_FORGOT_PASSWORD,
            component: () => import(/* webpackChunkName: 'auth' */ '@/views/auth/AuthForgotPassword.vue')
        },
        {
            path: '/resend-activation-email/:email',
            name: ROUTES_RESEND_ACTIVATION_EMAIL,
            component: () => import(/* webpackChunkName: 'auth' */ '@/views/auth/AuthResendActivationEmail.vue')
        }
    ]
};
